<div class="block_menu_desktop_products block_menu_desktop_item d-flex justify-content-between">
    <ul>
        <li>
            <h1>3D VISUALIZATION</h1>
        </li>
        <ng-container>
            <li>
                <a href="{{tailorfitSubdomain}}">TAilor Fit Custom Upholstery</a>
            </li>
            <li>
                <a routerLink="/draper" (click)="onRouterClick()">Sofas and Chairs</a>
            </li>
            <li>
                <a routerLink="/barstool" (click)="onRouterClick()">High Fashion Barstools</a>
            </li>
        </ng-container>
    </ul>
</div>